import { type HttpClient } from '@/application/interfaces/http-client';

import { getPaymentMethods } from './get-payment-methods';

const PaymentService = (httpClient: HttpClient.Instance) => ({
  getPaymentMethods: getPaymentMethods(httpClient),
});

export default PaymentService;
